import React from "react";
import { useApp } from "../context/AppContext";
import { useSite } from "../context/SiteContext";

const ABOUT_HERO =
  "https://images.unsplash.com/photo-1748302913353-90a60a1cba9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxwdW5rJTIwcm9jayUyMG11c2ljJTIwY3Jvd2QlMjBkYXJrfGVufDB8fHx8MTc3ODI4NTE3OHww&ixlib=rb-4.1.0&q=85";
const ABOUT_2 =
  "https://images.unsplash.com/photo-1738636591778-b4e73eb2748f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxzdHJlZXR3ZWFyJTIwaGVhdnklMjBtZXRhbCUyMGJsYWNrJTIwc2hpcnQlMjBmYXNoaW9ufGVufDB8fHx8MTc3ODI4NTE5OXww&ixlib=rb-4.1.0&q=85";

export default function About() {
  const { t } = useApp();
  const { s, img } = useSite();

  const title = s("about_title", t.about.title);
  const sub = s("about_subtitle", t.about.sub);
  const b1 = s("about_body_1", t.about.body_1);
  const b2 = s("about_body_2", t.about.body_2);
  const b3 = s("about_body_3", t.about.body_3);

  const heroImg = img("about_hero_image", ABOUT_HERO);
  const secondaryImg = img("about_secondary_image", ABOUT_2);

  const stats = [
    {
      v: s("about_stat_1_value", "12"),
      l: s("about_stat_1_label", t.about.stats_drops),
    },
    {
      v: s("about_stat_2_value", "08"),
      l: s("about_stat_2_label", t.about.stats_artists),
    },
    {
      v: s("about_stat_3_value", "24"),
      l: s("about_stat_3_label", t.about.stats_events),
    },
  ];

  return (
    <div data-testid="page-about">
      <section className="relative">
        <div className="absolute inset-0">
          <img src={heroImg} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-black" />
        </div>
        <div className="relative max-w-[1600px] mx-auto px-5 md:px-10 py-24 md:py-40">
          <p className="font-mono text-xs tracking-[0.3em] text-kult-yellow">/ ABOUT</p>
          <h1 className="font-display text-6xl md:text-9xl mt-3 leading-[0.9]">{title}</h1>
          <p className="font-display text-2xl md:text-3xl text-kult-pink mt-4">{sub}</p>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="space-y-8 text-lg md:text-xl leading-relaxed font-body">
          <p>{b1}</p>
          <p className="text-kult-muted border-l-4 border-kult-pink pl-6 italic">{b2}</p>
          <p>{b3}</p>
        </div>
      </section>

      <section className="border-y border-kult-border bg-kult-black2">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-16 grid grid-cols-3 gap-6">
          {stats.map((stat, i) => (
            <div key={i} className="text-center" data-testid={`about-stat-${i}`}>
              <p className="font-display text-6xl md:text-8xl text-kult-pink">{stat.v}</p>
              <p className="font-mono text-xs tracking-[0.3em] text-kult-muted mt-2">{stat.l}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        <img src={secondaryImg} alt="" className="aspect-[4/5] object-cover border border-kult-border" />
        <img src={heroImg} alt="" className="aspect-[4/5] object-cover border border-kult-border" />
      </section>
    </div>
  );
}
